import React, {Component} from "react";
import {APIClient} from "../utils/APIClient";
import {typedErrorMessage} from "../utils/typedErrorMessage";
import {ModalBody, ModalFooter} from "reactstrap";

export class EditElementModalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getSubmitUrl() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    getDataToSubmit(event) {
        throw new Error('This method must be overridden in the concrete component.');
    }

    renderSaveButton() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: true});
        const submit_url = this.getSubmitUrl();

        const dataToSubmit = this.getDataToSubmit(event)

        new APIClient(submit_url).call('PUT', dataToSubmit).then((response) => {
            this.setState({saving: false});
            if (response.status === 'ERROR') {
                alert(response['error_message']);
            } else if (typedErrorMessage(response)) {
                // Los errores TIPADOS del backend traen su código en `status`, así que no caen en
                // ninguna de las dos ramas de siempre y el guardado se quedaba mudo. Sólo se
                // atienden los códigos mapeados: un 200 de un endpoint sin `status` no entra acá.
                alert(typedErrorMessage(response));
            } else if (response.status === 'OK') {
                this.onSaved(response);
                this.props.onModified(response.data);
            }
        })
    }

    // Para el formulario que tiene algo que decir al guardar (el de presupuesto avisa que la línea se recalcula).
    onSaved(response) {
    }

    renderFormFields() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    {this.renderFormFields()}
                </ModalBody>
                <ModalFooter>
                    {this.renderSaveButton()}
                </ModalFooter>
            </form>
        )
    }
}
